module.exports = __webpack_public_path__ + "img/autarky_content_bg.ef65fb76.png";